import React from 'react';

import Usuario from '../index';

const Medico: React.FC = () => {
  return <Usuario tipo="Usuario" />;
};

export default Medico;
